import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './state';
import * as reducers from './reducers';


const journeyBuilderSlice = createSlice({
  initialState,
  reducers,
  name: 'journeyBuilder',
});

export const {
  setEdgesQueue,
  setEligibleNodeConnections,
  setJourney,
  setMultiEntity,
  setNodeConnectionType,
  setNodesQueue,
  setOverlappingEdges,
  setOverlappingNodes,
  setShouldLayout,
  setShowValidationErrors,
} = journeyBuilderSlice.actions;

export default journeyBuilderSlice.reducer;
